import * as React from "react";

import HandshakeIcon from "@mui/icons-material/Handshake";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import type { SxProps } from "@mui/material/styles";
import useTheme from "@mui/material/styles/useTheme";

import useSupademo from "setup/hooks/use-supademo.hook";

import { neutral } from "app/themes/colors";

type SupaDemoButtonProps = {
  tooltip?: string;
  label?: string;
  supaDemoId: string;
  isSideMenu?: boolean;
  sx?: SxProps;
};

export default function SupaDemoButton({
  supaDemoId,
  tooltip,
  label,
  isSideMenu = false,
  sx
}: SupaDemoButtonProps) {
  const Supademo = useSupademo();
  const theme = useTheme();
  if (!Supademo) {
    return null;
  }
  return (
    <Tooltip title={tooltip} placement="right">
      <Button
        size="small"
        variant={isSideMenu ? "borderless" : "outlined"}
        aria-label={label}
        startIcon={<HandshakeIcon />}
        sx={{
          color: neutral[50],
          fontSize: theme.typography.pxToRem(12),
          border: `1px solid ${neutral[50]}`,
          ...sx
        }}
        onClick={(e) => {
          Supademo.loadShowcase(supaDemoId);
        }}
      >
        <Typography>Assist Me</Typography>
      </Button>
    </Tooltip>
  );
}
